import { AfterViewInit, Component, OnInit } from '@angular/core';

import { EmitterService } from '../../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../../analytics/models/analytics.datamodel';

@Component({
	selector: 'app-partner-logo',
	styleUrls: ['./partner-logo.component.css'],
	templateUrl: './partner-logo.component.html'
})
export class PartnerLogoComponent implements OnInit, AfterViewInit {
	public isToggled = false;
	public logo = '';

	constructor(private analyticsDataModel: AnalyticsDataModel) {
		EmitterService.get(EVENT_EMITTERS.TOGGLE_LAYOUT).subscribe((response: any) => {
			this.isToggled = response;
			if (this.isToggled) {
				this.logo = this.analyticsDataModel.config.partner.partnerLogoIcon;
			} else {
				this.loadLogo();
			}
		});
	}

	ngOnInit(): void {}

	ngAfterViewInit(): void {
		this.loadLogo();
	}

	loadLogo(): void {
		this.logo = this.analyticsDataModel.config.partner.partnerLogo
			? this.analyticsDataModel.config.partner.partnerLogo
			: this.analyticsDataModel.setupData.partner.headerLogo;
	}
}
